import ProductDescription from './ProductDescription'

const RFIInfantMeatsProduct = {
  ...ProductDescription,
  category: '13',
  subCategory: '001RFI',
  IsBroadband: true,
  PackageType: '',
  Size: '2.5 ounces only',
  MultiPackageType: false,
  MultiPackageCount: null,
  Organic: false,
  NoAdditionalIngredients: false,
}

export default RFIInfantMeatsProduct
